module.exports = __webpack_public_path__ + "img/character_high_five.6c15af76.svg";